import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import CommonTable from "components/ViewTable/ViewTable";
import React, { useState } from "react";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";

interface SupplierDetailsViewProps {
  data: any;
}

const SupplierDetails: React.FC<SupplierDetailsViewProps> = ({ data }) => {
  const contactColumns = [
    {
      label: "Sr. No.",
      align: "center" as const,
      render: (_row: any, index?: number) => (index ?? 0) + 1,
    },
    {
      label: "Name",
      align: "center" as const,
      render: (contact: any) => contact.name || "—",
    },
    {
      label: "Designation",
      align: "center" as const,
      render: (contact: any) => contact.designation || "—",
    },
    {
      label: "Email",
      align: "center" as const,
      render: (contact: any) => contact.email || "—",
    },
    {
      label: "Phone Number",
      align: "center" as const,
      render: (contact: any) => contact.phone_number || "—",
    },
  ];
  return (
    <Card>
      <Card.Body>
        {/* Supplier Basic Information */}
        <Row className="mb-4">
          <Col md={6}>
            <p>
              <strong>Supplier Name:</strong> {data?.supplier_name || "—"}
            </p>
          </Col>
          <Col md={6}>
            <p>
              <strong>Supplier Type:</strong> {data?.supplier_type || "—"}
            </p>
          </Col>
          <Col md={6}>
            <p>
              <strong>Email:</strong> {data?.email || "—"}
            </p>
          </Col>
          <Col md={6}>
            <p>
              <strong>On Boarding Date:</strong> <FormattedDate date={data?.on_boarding_date} />
            </p>
          </Col>
          <Col md={6}>
            <p>
              <strong>Phone Number:</strong> {data?.phone_number || "—"}
            </p>
          </Col>
        </Row>

        <hr />

        {/* Contact Persons Table */}
        <Row>
          <Col md={12}>
            <h5 className="mb-3">Contact Person</h5>
            <CommonTable
              columns={contactColumns}
              data={data.contacts}
              tableClassName="common-table"
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SupplierDetails;
